import { providerApi } from '@/api/ProviderApi'
import { useQuery } from '@tanstack/react-query'

export const useFetchScheduleActions = () => {
	const {
		data: schedulingActions,
		isLoading,
		isError,
	} = useQuery({
		queryKey: ['fetch-scheduling-actions'],
		queryFn: () => providerApi.fetchSchedulingActions(),
		refetchInterval: 30000,
	})

	return {
		schedulingActions,
		isLoading,
		isError,
	}
}
